import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class GeofenceService {

  constructor(public http: Http, public mainService: MainService) { }

  findByUser(idUser:String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"geofence/findByUser/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByDevice(idDevice:String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"geofence/findByDevice/"+idDevice)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(geofence:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"geofence",geofence)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(geofence:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"geofence/"+geofence.idGeofence,geofence)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:number){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"geofence/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/geofence.service.ts